import { DealFileAttachmentHelper } from "@js/helpers/DealFileAttachmentHelper";
import { TrustAsHtmlHelper } from "@js/helpers/TrustAsHtmlHelper";
import { RoleService } from "@js/services/RoleService";
import { SelectListService } from "@js/services/SelectListService";
import { CompareResultsService } from "@js/services/CompareResultsService";
import {
  ApplicationUser,
  BridgingLenderResultSummaryDTO,
  Case,
  CaseClient,
  CaseStatusEnum,
  CommercialLenderResultSummaryDTO,
  Deal,
  FileAttachmentClient,
  LenderResult,
  LenderResultSummaryDTO,
  OrganisationClient,
  ProductClient,
  ProductFamilyEnum,
} from "@src/apis/ModularClient";
import { LenderLogoDTO } from "@js/DTO/LenderLogoDTO.cs";
import { CompareResultDTO } from "@js/ui-dto/CompareResultsDto";

export class ComparisonController {
  isLoading: boolean;

  selectedCandidates: (LenderResultSummaryDTO | CommercialLenderResultSummaryDTO | BridgingLenderResultSummaryDTO)[];
  allResults: (LenderResultSummaryDTO | CommercialLenderResultSummaryDTO | BridgingLenderResultSummaryDTO)[];
  rowSelected: number[] = [];

  //Lender Logos
  showLenderLogo: boolean = false;
  lenderIds: number[] = [];
  urlLenders: LenderLogoDTO[] = [];

  selectedUser: ApplicationUser;

  enquiryOpen: boolean;
  enquiryEmail: string;
  enquiryBody: string;

  isBroker: boolean = false;

  isIntroducer: boolean = false;

  searchid: number;
  caseid: number;
  uniqueid: string;
  isLenderVisible: boolean;
  showAdditionalProductInfoModal: LenderResult;
  case: Case;
  isDeal: boolean = false;

  criteria: CompareResultDTO;

  productTypeOptions = [];
  productLastVerifiedDates = {};

  isLoggedInUser: boolean = false;

  static $inject = [
    "$scope",
    "$rootScope",
    "$cookies",
    "$location",
    "$http",
    "RoleService",
    "FileAttachmentClient",
    "OrganisationClient",
    "CaseClient",
    "$routeParams",
    "SelectListService",
    "ProductClient",
    "CompareResultsService",
    "$sce",
    "TrustAsHtmlHelper",
  ];

  constructor(
    private $scope: ng.IScope,
    private $rootScope: ng.IRootScopeService,
    private $cookies: ng.cookies.ICookiesService,
    private $location: ng.ILocationService,
    private $http: ng.IHttpService,
    private roleService: RoleService,
    private fileAttachmentClient: FileAttachmentClient,
    private organisationClient: OrganisationClient,
    private caseClient: CaseClient,
    private $routeParams: ng.route.IRouteParamsService,
    private selectListService: SelectListService,
    private productClient: ProductClient,
    private compareResultsService: CompareResultsService,
    private $sce: ng.ISCEService,
    private trustAsHtmlHelper: TrustAsHtmlHelper,
  ) {
    this.isDeal = this.$routeParams.isDeal ? true : false;

    if (this.$routeParams.SearchId) {
      this.searchid = this.$routeParams.SearchId;
    }
    this.showOrHideLenderLogo();
    this.productTypeOptions = this.selectListService.GetProductTypeOptions();

    if ($cookies.get("access_token")) {
      this.isLoggedInUser = true;
    }

    if (sessionStorage.getItem("UniqueId")) {
      this.uniqueid = sessionStorage.getItem("UniqueId");
    }

    this.allResults = JSON.parse(sessionStorage.getItem("TempSavedResults"));

    //We are sending caseId has 0 for bridging
    if (this.$routeParams.CaseId && this.$routeParams.CaseId > 0) {
      this.caseid = this.$routeParams.CaseId;
    }

    if ((this.$rootScope as any).selectedUser || sessionStorage.getItem("SelectedUser")) {
      if ((this.$rootScope as any).selectedUser) {
        this.selectedUser = (this.$rootScope as any).selectedUser;
        sessionStorage.setItem("SelectedUser", JSON.stringify(this.selectedUser));
      } else if (sessionStorage.getItem("SelectedUser")) {
        this.selectedUser = JSON.parse(sessionStorage.getItem("SelectedUser"));
      }

      this.checkForBrokerOrIntroducer();
    }

    if (sessionStorage.getItem("ComparisonList") && this.compareResultsService.exists()) {
      this.selectedCandidates = JSON.parse(sessionStorage.getItem("ComparisonList"));

      if (this.selectedCandidates) {
        for (var i = 0; i < this.selectedCandidates.length; i++) {
          this.getUrls(this.selectedCandidates[i].id, this.selectedCandidates[i].logoURL);
        }
        const productIds = this.selectedCandidates.map((product) => product.productID);
        this.getProductLastVerifiedDates(productIds);
      }

      this.criteria = this.compareResultsService.load();
    } else {
      this.goToResults();
    }
  }

  getUrls(id: number, url: string) {
    if (url == null) return null;

    this.fileAttachmentClient.getAmazonFileAccessUri(url).then((response) => {
      var LenderLogoDTO = {
        Id: id,
        LogoURL: response,
      } as LenderLogoDTO;

      this.urlLenders.push(LenderLogoDTO);
    });
  }

  checkForBrokerOrIntroducer(): void {
    //Check if broker
    this.roleService.isBrokerOrABove().then((response) => {
      this.isBroker = response;
    });
    this.roleService.isIntroducer().then((response) => {
      this.isIntroducer = response;
    });
  }

  showOrHideLenderLogo() {
    this.organisationClient.showLenderNamesAndLogos(this.searchid, this.isDeal).then((result) => {
      this.showLenderLogo = result;
    });
  }

  getLogoURL(id: number) {
    var found = this.urlLenders.find((x) => x.Id == id);

    if (found) {
      return found.LogoURL;
    } else {
      return "";
    }
  }

  sendEnquiry(): void {
    this.enquiryOpen = false;
  }

  goToDealResults(dealCriteria: CompareResultDTO, shortlistingMore: boolean = false) {
    var route = shortlistingMore ? "shortlistmore" : "results";
    var enterpriseRoute = !this.isLoggedInUser && !shortlistingMore ? "/e" : "";

    if (dealCriteria.productFamily === ProductFamilyEnum.Development) {
      this.$location.path(enterpriseRoute + "/devfinance" + route + "/" + this.searchid);
    }

    if (dealCriteria.productFamily === ProductFamilyEnum.Bridging) {
      console.log(enterpriseRoute + "/bridging" + route + "/" + this.searchid);
      this.$location.path(enterpriseRoute + "/bridging" + route + "/" + this.searchid);
    }

    if (dealCriteria.productFamily === ProductFamilyEnum.Commercial) {
      this.$location.path(enterpriseRoute + "/commercial" + route + "/" + this.searchid);
    }
  }

  goToResults(): void {
    //Clearing the all lsd data(except 'LoanCriteria') saved for this view.
    sessionStorage.removeItem("TempSavedResults");
    sessionStorage.removeItem("SelectedUser");
    sessionStorage.removeItem("UniqueId");

    if (this.caseid && this.searchid) {
      this.caseClient.fetch(this.caseid).then((result) => {
        if (
          result.caseStatus == CaseStatusEnum.ReadyToReSubmit ||
          result.caseStatus == CaseStatusEnum.SubmittedToLendersForHoT
        ) {
          this.$location.path("/shortlistmore/" + this.searchid + "/" + this.caseid);
        } else {
          if (this.isDeal) {
            this.goToDealResults(this.criteria);
          } else {
            this.$location.path("/results/" + this.searchid + "/" + this.caseid);
          }
        }
      });
    } else if (this.searchid || this.isDeal) {
      if (this.isDeal) {
        sessionStorage.setItem("ComparisonList", JSON.stringify(this.selectedCandidates));

        if (sessionStorage.getItem("DealClientUniqueRef")) {
          this.$location.path("/referredsearchdeal/" + sessionStorage.getItem("DealClientUniqueRef") + "/false");
          sessionStorage.removeItem("DealClientUniqueRef");
        } else {
          const dealCriteria = this.criteria;
          if (
            dealCriteria.dealStatus == CaseStatusEnum.ReadyToReSubmit ||
            dealCriteria.dealStatus == CaseStatusEnum.SubmittedToLendersForHoT
          ) {
            var shortlistingMore = true;
            this.goToDealResults(dealCriteria, shortlistingMore);
          } else {
            this.goToDealResults(dealCriteria);
          }
        }
      } else {
        this.$location.path("/results/" + this.searchid);
      }
    } else {
      if (this.uniqueid) {
        this.$location.path("/referredSearch/" + this.uniqueid);
      } else {
        this.$location.path("/results");
      }
    }
  }

  go(path): void {
    this.$location.path(path);
  }

  hideLenderName(label) {
    let newLabel = label.replace(/ *\([^)]*\) */g, "");
    return newLabel;
  }

  getProductLastVerifiedDates(productIds: (number | null)[]) {
    productIds = productIds.filter((item) => item !== null);
    this.productClient.getLastVerifiedDates(productIds).then((response) => {
      productIds.forEach((id) => {
        if (response[id] != null) {
          this.productLastVerifiedDates[id] = this.formatDate(response[id]);
        }
      });
    });
  }

  formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB");
  };

  trustAsHtml(content) {
    return this.trustAsHtmlHelper.trustAsHtml(content);
  }
}
